module.exports = "https://de18y2hs3hlxs.cloudfront.net/ea0f2244-3733-4462-8521-3c67071db2f1/images/notepad-2.png?93936d7ca0aada75a2e9c11d9bd6e63d";